// extracted by mini-css-extract-plugin
export default {"Input":"index_Input_K60oh","error":"index_error_ASAcH"};